import ProcessingAnimation from "features/shared/styles/ProcessingAnimation.styled";
import styled from "styled-components";

import Container from "features/shared/styles/container/Container.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";

const LoaderContainer = styled(Container)`
  height: 500px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
  gap: 24px;

  .loader-animation {
    height: 137px;
    width: 137px;
  }

  .airline-logo {
    height: 32px;
  }

  ${MicroHeader} {
    margin-top: 10px;
    white-space: pre-wrap;
    text-align: center;
  }

  ${ProcessingAnimation} {
    max-width: 800px;
  }
`;
export default LoaderContainer;
